<template>
  <v-card class="max-shadow" @click="$emit('click', ticket)">
    <v-card-title class="px-1">
      <v-container grid-list-xs class="pa-0">
        <v-layout column wrap class="px-3">
          <v-layout row wrap align-center justify-space-between>
            <span class="subheading font-weight-medium">{{
              ticket.title
            }}</span>
            <span>{{ formatTime(ticket.createdAt) }}</span>
          </v-layout>
          <span class="caption pt-1">{{
            ticket.categoryName || ticket.description
          }}</span>
        </v-layout>
      </v-container>
    </v-card-title>
    <v-card-actions class="pt-0">
      <v-container grid-list-xs class="pa-0">
        <v-layout row wrap class="py-2">
          <v-flex>
            <v-layout row wrap align-center>
              <div class="px-2">
                <avatar
                  :text="ticket.createdBy.name"
                  :size="32"
                  :src="ticket.createdBy.photo"
                />
              </div>
              <v-layout column wrap class="px-2">
                <div class="caption">Created By:</div>
                <div class="subheading font-weight-medium">
                  {{ ticket.createdBy.name }}
                </div>
              </v-layout>
            </v-layout>
          </v-flex>
          <v-flex>
            <v-layout row wrap align-center justify-space-around>
              <div class="px-2">
                <avatar
                  :text="ticket.assignedTo.name"
                  :size="32"
                  :src="ticket.assignedTo.photo"
                />
              </div>
              <v-layout column wrap class="px-2">
                <div class="caption">Assigned To:</div>
                <div class="subheading font-weight-medium">
                  {{ ticket.assignedTo.name }}
                </div>
              </v-layout>
            </v-layout>
          </v-flex>
          <v-flex>
            <v-layout row wrap align-center justify-center>
              <span :class="getStatusColor(ticket.status)">{{
                ticket.status
              }}</span>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>
<script>
import * as moment from 'moment';
import Avatar from '@/components/common/Avatar';
import { firestore } from '@/firebase';
import _get from 'lodash/get';

export default {
  components: {
    avatar: Avatar,
  },
  props: {
    ticket: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    role() {
      return _get(this.$store.state.profile, 'role');
    },
    settingsRef() {
      return this.role === 'admin'
        ? firestore.collection('tenants').doc(this.cid)
        : firestore.doc('settings/helpDesk');
    },
  },

  mounted() {
    if (this.ticket && !this.ticket.assignedTo) {
      this.ticket.assignedTo = {};
      this.getHelpDeskAdmin();
    }
  },

  methods: {
    getHelpDeskAdmin() {
      this.settingsRef.get().then((adminSnaphot) => {
        const data = adminSnaphot.data() || {};
        const admin =
          this.$store.state.profile.role === 'admin'
            ? data.helpDeskAdmin
            : data.admin;

        if (this.ticket && !this.ticket.assignedTo.uid) {
          this.ticket.assignedTo = admin;
        }
      });
    },
    getStatusColor(status) {
      return status === 'closed'
        ? 'red--text subheading'
        : 'green--text subheading';
    },
    formatTime(timestamp) {
      const date = timestamp.toDate();
      const today = moment().startOf('day');
      return moment(date).isAfter(today)
        ? moment(date).fromNow()
        : moment(date).calendar(today, {
            lastWeek: 'D MMM [at] hh:mm A',
            sameElse: 'D MMM [at] hh:mm A',
          });
    },
  },
};
</script>
